// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"c6c7f3bc","342":"b1062ba3","543":"0901a7c9","642":"30713044","881":"0cba7d38"}[chunkId] + ".chunk.css";
};